import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PlusCircle, MinusCircle } from 'lucide-react';
import PropTypes from 'prop-types';

const SuitorsArrayFieldTemplate = ({ className, disabled, items, onAddClick, title, uiSchema }) => {
  const isHidden = uiSchema && uiSchema.items && uiSchema.items['ui:hidden'];
  if (isHidden) return null;

  const renderAddButton = () => (
    <button
      onClick={onAddClick}
      data-cy={`${String(title).toLowerCase()}-add`}
      disabled={disabled}
      type="button"
      className={`
        flex items-center gap-0.5 px-0 py-1.5 text-[10px] font-normal transition-all
        ${disabled 
          ? 'text-gray-300 cursor-not-allowed' 
          : 'text-[#007bff] hover:text-[#0056b3] active:scale-95'
        }
      `}
    >
      <PlusCircle size={18} />
      <FormattedMessage id="ADD_SUITOR" />
    </button>
  );

  return (
    <div className={className} style={isHidden ? { display: 'none' } : {}}>
      {!items?.length && (
        <div className="flex items-center gap-1 mb-3 ml-[-4px]">
          {renderAddButton()}
        </div>
      )}

      {items?.map((element) => (
        <div key={element.index} className="w-full">
          <div className="flex flex-col">
            <div className="w-full">
              {element.children}
            </div>

            <div className="flex items-center gap-1 mb-3 ml-[-4px]">
              {element.index === items.length - 1 && renderAddButton()}

              {items.length > 1 && (
                <button
                  disabled={disabled}
                  type="button"
                  className={`
                    flex items-center gap-0.5 px-0 py-1.5 text-[10px] font-normal transition-all
                    ${disabled 
                      ? 'text-gray-300 cursor-not-allowed' 
                      : 'text-[#dc3545] hover:text-[#c82333] active:scale-95'
                    }
                  `}
                  onClick={element.onDropIndexClick(element.index)}
                  data-cy={`${String(title).toLowerCase()}-remove`}
                >
                  <MinusCircle size={18} />
                  <FormattedMessage id="REMOVE_SUITOR" />
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

SuitorsArrayFieldTemplate.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  items: PropTypes.array.isRequired,
  onAddClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  uiSchema: PropTypes.object,
};

SuitorsArrayFieldTemplate.defaultProps = {
  className: '',
  disabled: false,
  uiSchema: {},
};

export default SuitorsArrayFieldTemplate;
